import React, { useEffect, useState } from "react";
import { FiCheck, FiLoader } from "react-icons/fi";
import { useI18n } from "./i18n";

export default function UploadPreparation({ preparation, compact = false }) {
  const { t } = useI18n();
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [preparation.startedAt]);
  const elapsed = Math.max(0, Math.floor((now - preparation.startedAt) / 1000));
  const stage = ["waiting", "checking", "extracting", "converting", "saving"].includes(preparation.stage)
    ? preparation.stage : "preparing";

  return (
    <div className={`upload-preparation${compact ? " upload-preparation--compact" : ""}`}>
      {!compact && (
        <div className="upload-preparation-complete">
          <FiCheck aria-hidden="true" />
          <span>{t("upload.transferComplete")}</span>
          <span className="upload-preparation-percent">100%</span>
        </div>
      )}
      <div className="upload-preparation-current" role="status">
        <FiLoader className="upload-preparation-spinner" aria-hidden="true" />
        <span>{t(`upload.preparation.${stage}`)}</span>
      </div>
      {elapsed >= 5 && <div className="upload-preparation-elapsed">{t("upload.preparationElapsed", { seconds: elapsed })}</div>}
      {!compact && elapsed >= 10 && <div className="upload-preparation-hint">{t(preparation.continuesInBackground ? 'upload.preparationBackgroundHint' : 'upload.preparationHint')}</div>}
    </div>
  );
}
